import { type ReactElement } from 'react';

interface SequenceBadgeProps {
  /** Posição da conversa atual na sequence (1-indexed). */
  position: number;
  /** Total de conversas na sequence. */
  total: number;
  /** Flag highVolume ativa → cor de alerta. */
  highVolume?: boolean;
  /** Flag escalatingSentiment ativa → cor crítica. */
  escalating?: boolean;
}

/**
 * SequenceBadge — Fatia F (ADR-055 §F3) — Fase C Brief 2A r7b DS canonical.
 *
 * Badge "S 3/5" em cards de listagem. Cores via DS v2.3.0 (Fase A.1-γ GAP-1 resolved):
 *   - .sequence-badge--warning: highVolumeFlag ativa (3+ em 24h) — token --sequence-warning-*.
 *   - .sequence-badge--danger:  escalatingSentimentFlag ativa — token --sequence-danger-*.
 *   - .sequence-badge--normal:  default — token --sequence-normal-*.
 *
 * Vide governance/specifications/Brief_2A_V23_r7b_Operational_Specification.md §1.1 GAP-1.
 */
export function SequenceBadge({
  position,
  total,
  highVolume,
  escalating,
}: SequenceBadgeProps): ReactElement {
  let variant = 'sequence-badge--normal';
  if (escalating === true) variant = 'sequence-badge--danger';
  else if (highVolume === true) variant = 'sequence-badge--warning';

  return (
    <span
      role="status"
      aria-label={`Sequência ${position.toString()} de ${total.toString()}`}
      className={`sequence-badge ${variant}`}
    >
      S {position.toString()}/{total.toString()}
    </span>
  );
}
